import { defineMessages } from "@/i18n";
import en from "./en";

export const compactMessages = defineMessages("compact", en);
